import React, {FunctionComponent} from 'react';
import {useQuery} from '@tanstack/react-query';

import {useCompareParams} from './CompareContent';
import CompareSectionsPage from '../../partials/compare/CompareSectionsPage';
import {useCompareAccommodationQueryConfig} from '../../../query/Compare/Query';

interface Props {}

const CompareAccommodation: FunctionComponent<Props> = () => {
    const [universityIds] = useCompareParams();

    const [compareConfig] = useCompareAccommodationQueryConfig(universityIds);
    const compareQuery = useQuery(compareConfig);

    if(!compareQuery.data)
        return null;

    return (
        <CompareSectionsPage parts={compareQuery.data} />
    );
};

export default CompareAccommodation;
